import _ from 'lodash'

export default {
  roomQuestionList: (state, getters, roomGetters) => {
    let roomQuestionList = state.roomQuestionList.filter(rq => !rq.isDel)
    roomQuestionList = _.orderBy(roomQuestionList, ['isPin', 'regDate'], ['desc', 'asc'])

    return roomQuestionList
  },

  getQuestion: (state, getters, rootState) => (roomQuestionId) => {
    let roomQuestion = getters.roomQuestionList.find(rq => rq.roomQuestionId == roomQuestionId)

    return roomQuestion;
  },

  myQuestionList: (state, getters, rootState, roomGetters) => {
    let MyQuestionList = getters.roomQuestionList.filter(qs => qs.userId === roomGetters['user/me'].userId)
    
    return MyQuestionList
  },

  isNewQuestion: (state, getters, rootState) => {
    return state.isNewQuestion
  },

  currentQuestion: (state, getters, rootState) => {
    return state.currentQuestion
  },

  isModalQuestion: (state, getters, rootState) => {
    return state.isModalQuestion
  },

  // 질문 공개 여부
  questionOpenStatus: (state, getters, rootState, roomGetters) => {
    return state.questionOpenStatus;
  },
};
